<template>
  <div class="page-header">
    <div class="search">
      <!-- 前置插槽 -->
      <slot name="prev"
        ref="slotPref"></slot>
      <el-form ref="headSearchForm"
        @submit.native.prevent
        :model="form">
        <template v-for="(item, key) in options">
          <el-form-item v-if="key < showItemLength"
            :key="key"
            :prop="item.id">
            <!-- 输入框 -->
            <template v-if="item.type === 'input'">
              <el-input v-model="form[item.id]"
                :style="'width:' + item.width"
                size="small"
                :placeholder="item.label"
                @input="forceUpdate"
                @keyup.enter.native="handleChangeInput(item.update)"></el-input>
            </template>

            <!-- 下拉选择 -->
            <template v-if="item.type === 'select'">
              <el-select v-model="form[item.id]"
                :disabled="item.disabled || false"
                :multiple="item.multiple || false"
                :collapse-tags="item.multiple || false"
                size="small"
                :placeholder="item.label"
                :filterable="item.filterable"
                @change="function(val){ changeHandle(item, val)}">
                <el-option v-if="item.options.length > 1 && !item.notAll"
                  value
                  label="全部"></el-option>
                <el-option v-for="option in item.options"
                  :key="item.id+'_'+option.value"
                  :label="option.name"
                  :value="option.value">
                </el-option>
              </el-select>
            </template>

            <!-- 级联选择 -->
            <template v-if="item.type === 'cascader'">
              <el-cascader v-model="form[item.id]"
                :options="item.options"
                :disabled="item.disabled || false"
                :props="item.props"
                size="small"
                :show-all-levels="item.showAllLevels || false"
                :filterable="item.filterable || false"
                :placeholder="item.label"
                clearable
                @change="function(val){changeHandle(item, val)}"></el-cascader>
            </template>

            <!-- 日期选择器 -->
            <template v-if="item.type === 'datePicker'">
              <el-date-picker v-model="form[item.id]"
                size="small"
                :clearable="(!!!item.closeClearable?true:false)"
                :type="item.dateType || 'date'"
                :value-format="item.valueFormate || 'yyyy-MM-dd'"
                :formate="item.formate || 'yyyy-MM-dd'"
                :picker-options="item['picker-options'] || {}"
                :placeholder=" item.label"
                @change="function(val){changeHandle(item, val)}"
                @input="forceUpdate">
              </el-date-picker>
            </template>

            <!-- 日期时间选择器 -->
            <template v-if="item.type === 'dateTimePicker'">
              <el-date-picker v-model="form[item.id]"
                size="small"
                :type="item.dateType || 'datetime'"
                :formate="item.formate || 'yyyy-MM-dd HH:mm'"
                :value-format="item.valueFormate || 'yyyy-MM-dd HH:mm:ss'"
                :picker-options="item['picker-options'] || {}"
                :placeholder=" item.label"
                @input="forceUpdate">
              </el-date-picker>
            </template>
          </el-form-item>
        </template>
        <!-- todolist 展开更多的动画顿了一下 -->
        <el-collapse-transition>
          <div v-show="showMore"
            style="width:100%;">
            <template v-for="(item, key) in options">
              <el-form-item v-if="key > (showItemLength - 1)"
                :key="key"
                :prop="item.id">
                <!-- 输入框 -->
                <template v-if="item.type === 'input'">
                  <el-input v-model="form[item.id]"
                    :style="'width:' + item.width"
                    size="small"
                    :placeholder="item.label"
                    @input="forceUpdate"
                    @keyup.enter.native="handleChangeInput(item.update)"></el-input>
                </template>

                <!-- 下拉选择 -->
                <template v-if="item.type === 'select'">
                  <el-select v-model="form[item.id]"
                    :disabled="item.disabled || false"
                    :multiple="item.multiple || false"
                    :collapse-tags="item.multiple || false"
                    size="small"
                    :placeholder="item.label"
                    @change="function(val){ changeHandle(item, val)}">
                    <el-option v-if="item.options.length > 1 && !item.notAll"
                      value
                      label="全部"></el-option>
                    <el-option v-for="option in item.options"
                      :key="item.id+'_'+option.value"
                      :label="option.name"
                      :value="option.value">
                    </el-option>
                  </el-select>
                </template>

                <!-- 级联选择 -->
                <template v-if="item.type === 'cascader'">
                  <el-cascader v-model="form[item.id]"
                    :options="item.options"
                    :disabled="item.disabled || false"
                    :props="item.props"
                    size="small"
                    :show-all-levels="item.showAllLevels || false"
                    :filterable="item.filterable || false"
                    :placeholder="item.label"
                    clearable
                    @change="function(val){changeHandle(item, val)}"></el-cascader>
                </template>

                <!-- 日期选择器 -->
                <template v-if="item.type === 'datePicker'">
                  <el-date-picker v-model="form[item.id]"
                    size="small"
                    :clearable="(!!!item.closeClearable?true:false)"
                    :type="item.dateType || 'date'"
                    :value-format="item.valueFormate || 'yyyy-MM-dd'"
                    :formate="item.formate || 'yyyy-MM-dd'"
                    :picker-options="item['picker-options'] || {}"
                    :placeholder=" item.label"
                    @change="function(val){changeHandle(item, val)}"
                    @input="forceUpdate">
                  </el-date-picker>
                </template>

                <!-- 日期时间选择器 -->
                <template v-if="item.type === 'dateTimePicker'">
                  <el-date-picker v-model="form[item.id]"
                    size="small"
                    :type="item.dateType || 'datetime'"
                    :formate="item.formate || 'yyyy-MM-dd HH:mm'"
                    :value-format="item.valueFormate || 'yyyy-MM-dd HH:mm:ss'"
                    :picker-options="item['picker-options'] || {}"
                    :placeholder=" item.label"
                    @input="forceUpdate">
                  </el-date-picker>
                </template>
              </el-form-item>
            </template>
          </div>
        </el-collapse-transition>
      </el-form>
      <div class="buttons text-right">
        <transition name="fade">
          <el-button v-if="updateMoreBtn"
            type="text"
            size="medium"
            @click="showMore = !showMore">展开<i class="el-icon-arrow-down"
              :class="{'more': showMore}"></i></el-button>
        </transition>
        <el-button class="search-button"
          type="primary"
          size="small"
          @click="searchHandle">查询</el-button>
        <el-button class="search-button"
          size="small"
          @click="resetHandle">重置</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: 'TableSearch',
  props: {
    searchs: {
      required: true,
      type: Array,
    }
  },
  data() {
    return {
      options: [],
      showMore: false,
      form: {},
      showItemLength: 4,
      itemAverageWidth: 210, // 筛选项的平均宽度（默认都是200px + 10px右边距）
    }
  },
  computed: {
    ...mapGetters({
      getCollapse: 'getCollapse'
    }),
    // 展开更多的按钮是否显示
    updateMoreBtn() {
      return this.options.length > this.showItemLength
    }
  },
  watch: {
    // 侧边导航展开和收起时更新头部第一行筛选项的个数
    getCollapse(val) {
      if (this.$refs['headSearchForm'].$el.clientWidth) {
        if (val) {
          // 等待展开动画结束后再更新个数
          setTimeout(() => {
            this.showItemLength = Math.floor((this.$refs['headSearchForm'].$el.clientWidth) / this.itemAverageWidth)
          }, 500)
        } else {
          // 收起时立刻更新个数
          this.showItemLength = Math.floor((this.$refs['headSearchForm'].$el.clientWidth - 200) / this.itemAverageWidth)
        }
      }
    },
  },
  created() {
    this.updateValue()
  },
  mounted() {
    this.updateSearchAuth()
    this.updateSearchRowLength()
  },
  // 销毁组件数据
  beforeDestroy() {
    // this.$store.dispatch('updateTableQuery', {})
  },
  methods: {
    // 设置更新默认值
    updateValue() {
      this.searchs.forEach((elem) => {
        if (elem.value || elem.value === 0) this.form[elem.id] = elem.value
        if (elem.value === '') this.form[elem.id] = ''
      })
      // 父组件可以监听到查询按钮的点击，用于分开使用
      this.$store.dispatch('updateTableQuery', { ...this.form })
    },
    // 更新头部筛选的权限
    updateSearchAuth() {
      this.options = this.$route.meta.hideQuerys ?
        this.searchs.filter((elem) => !this.$route.meta.hideQuerys[elem.id]) :
        this.searchs
    },
    // 更新头部筛选第一行的筛选个数，动态更新第一行和展开的筛选项
    updateSearchRowLength() {
      let that = this

      // 项目兼容最小宽度1200，平均宽度算法取前四个。210 --筛选项的平均宽度（默认都是200px + 10px右边距）
      let average = this.options.length > 4 ? 4 : this.options.length
      let arr = this.options.slice(0, average).map((item) => item.width ? parseInt(item.width) + 10 : 210)
      let result = arr.reduce((prev, cur) => prev + cur)
      this.itemAverageWidth = result / average


      // 更新头部第一行筛选项的个数
      this.showItemLength = Math.floor(this.$refs['headSearchForm'].$el.clientWidth / this.itemAverageWidth)
      // 监听窗口大小变化，更新头部第一行隐藏筛选快的个数
      window.onresize = function () {
        if (that.$refs['headSearchForm'].$el.clientWidth) {
          that.showItemLength = Math.floor(that.$refs['headSearchForm'].$el.clientWidth / that.itemAverageWidth)
        }
      }
    },
    resetHandle() {
      this.$refs['headSearchForm'].resetFields()
      this.$store.dispatch('updateTableQuery', { ...this.form })
      this.forceUpdate()

      // 父组件可以监听到重置按钮的点击，用于分开使用
      this.$emit('resetSearch', { ...this.form })
    },
    // 点击查询，抛出数据触发查询事件
    searchHandle() {
      this.$store.dispatch('updateTableQuery', { ...this.formTrim(this.form) })

      // 父组件可以监听到查询按钮的点击，用于分开使用
      this.$emit('submitSearch', { ...this.formTrim(this.form) })
    },
    // 下拉框数据更新时，抛出数据触发对应事件，并清空影响的关键表单项数据
    changeHandle(item, val) {
      this.forceUpdate()

      if (item.change) this.form[item.change] = null
      this.$emit(item.id, val)

      // if (item.update !== false) { //item.update!==false，更新列表，默认下拉更改查询
      //   this.$store.dispatch('updateTableQuery', { ...this.formTrim(this.form) })
      // }
    },
    //input框回车事件
    handleChangeInput(flag = true) {
      if (flag) { //item.update!==false，更新列表，默认回车查询
        this.$store.dispatch('updateTableQuery', { ...this.formTrim(this.form) })
      }
    },
    // 下拉框和时间选择组件数据数据没有自动更新，手动强制刷新
    forceUpdate() {
      this.$forceUpdate()
    },
    // 只对输入框的表单项进行前后去空格的处理
    formTrim(form) {
      for (let key in form) {
        let item = this.options.find(elem => (elem.type === 'input' && elem.id === key))
        if (item && form[key]) form[key] = form[key].trim()
      }
      return form
    }
  }
}
</script>

<style lang="scss" scoped>
// 表格页面头部筛选统一样式
.page-header {
  margin-bottom: 10px;
  flex-shrink: 0;

  /deep/ .search {
    padding: 8px 24px 0 16px;
    background-color: #fff;
    border-radius: 1px;
    display: flex;
    flex-direction: row;

    .el-form {
      display: flex;
      flex-wrap: wrap;
      flex: 1;
      .el-form-item {
        margin-bottom: 8px;
        margin-right: 10px;
        float: left;

        .el-form-item__label {
          font-size: 12px;
        }

        .el-select,
        .el-cascader,
        .el-input {
          width: 200px;
        }

        .monthDate .el-date-packer_header {
          display: none;
        }
      }
    }

    .buttons {
      width: 210px;
      height: 34px;
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
      .el-button--text {
        height: 34px;
      }
      .el-icon-arrow-down {
        transition: all 0.5s;
        padding: 0 2px;
      }
      .search-button {
        width: 64px;
        font-size: 14px;
        padding: 8px 15px;
      }
      .more {
        transform: rotate(180deg);
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// ../vue-common-laboratory/src/components/Table/TableSearch/index.vue